import { ObjectId } from "mongodb";

import { ICustomQuestionGetResponse } from "@performyard/models";

import { SearchServiceSort } from "../../hooks";

import request from "../base-request";

export declare interface CustomQuestionData {
	data: {
		results: ICustomQuestionGetResponse[];
		maxAllowedCustomQuestions: number;
		customQuestionsCount: number;
	};
	errors: string[];
	warnings: string[];
}

export type CustomQuestionPatch = {
	question?: string;
	scale?: string;
	factor?: string;
	subfactor?: string;
	enabled?: boolean;
	custom_factor?: string | null;
};

export const scaleTypeMap = {
	likert5: "Likert-5",
	nps: "NPS",
	text: "Comment Box",
};

export const getEngagementSurveyCustomQuestions = async (sort?: SearchServiceSort, search = "") => {
	let urlAppend = sort ? `?sortOn=${sort.name}&sortDirection=${sort.direction}` : "";
	if (search) {
		urlAppend += sort ? `&search=${search}` : `?search=${search}`;
	}
	try {
		const [customQuestions] = await request<CustomQuestionData>(`/api/engagement/custom_question/${urlAppend}`);
		if (customQuestions.errors.length > 0) {
			throw new Error(customQuestions.errors[0]);
		}
		return customQuestions?.data;
	} catch (error) {
		throw error;
	}
};

export const patchEngagementSurveyCustomQuestion = async (question: Partial<ICustomQuestionGetResponse>) => {
	const editableFields = ["question", "scale", "factor", "subfactor", "enabled", "custom_factor"];
	// get only the fields that are editable
	const questionPatch: CustomQuestionPatch = Object.keys(question).reduce((acc, key) => {
		if (editableFields.includes(key)) {
			acc[key] = question[key];
		}
		return acc;
	}, {} as CustomQuestionPatch);

	const [updatedQuestion] = await request(`/api/engagement/custom_question/${question._id}`, {
		method: "PATCH",
		body: JSON.stringify(questionPatch),
	});
	return updatedQuestion;
};

export const deleteEngagementSurveyCustomQuestion = async (questionID: ObjectId) => {
	const [deletedQuestion] = await request(`/api/engagement/custom_question/${questionID}`, {
		method: "DELETE",
	});
	return deletedQuestion;
};

export const createEngagementSurveyCustomQuestion = async (question: Partial<ICustomQuestionGetResponse>) => {
	const [createdQuestion] = await request(`/api/engagement/custom_question`, {
		method: "POST",
		body: JSON.stringify(question),
	});
	return createdQuestion;
};
